import { useState } from 'react';

import { ResourceCostChartWidget } from './_components/ResourceCostChartWidget';
import { useWorkloadResourceCostChartData } from './_hooks/useWorkloadResourceCostChartData';
import { MEMORY_FIELDS } from './constants';

const MEMORY_COST_TOOLTIP_TEXT =
  'Cost per requested GB based on memory compute spend divided by requested memory GB.';

export const MemoryCostChartWidget = () => {
  const [costRate, setCostRate] = useState<'hourly' | 'daily' | 'monthly'>(
    'daily'
  );
  const {
    data,
    averageCost,
    isLoading,
    error,
    refetch,
    timeZone,
    isRangeSupported,
  } = useWorkloadResourceCostChartData(costRate, MEMORY_FIELDS);

  return (
    <ResourceCostChartWidget
      title="Memory cost"
      testId="memory-cost-card"
      metricLabel="Cost per requested GB"
      metricInfoTooltip={MEMORY_COST_TOOLTIP_TEXT}
      metricTestId="memory-cost-metrics-box"
      failedToLoadTitle="Failed to load memory cost"
      hasOfferingBreakdown
      costRate={costRate}
      onCostRateChange={setCostRate}
      data={data}
      averageCost={averageCost}
      isLoading={isLoading}
      error={error}
      refetch={refetch}
      timeZone={timeZone}
      isRangeSupported={isRangeSupported}
      chartTestId="memory-cost-chart"
      tooltipTestId="memory-cost-tooltip"
      unsupportedRangeTestId="memory-cost-card-unsupported-range"
    />
  );
};
